import http from '../plugins/axios'
import { queryGetOrderCount } from './graphql/queries/order/orderCount'

export const getAllOrderList = async (params) => {
  try {
    const response = await http.get(`/api/v2/orders/admin`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailOrder = async (orderId, params) => {
  try {
    const response = await http.get(`/api/v2/orders/${orderId}`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailOrderAdmin = async (params) => {
  try {
    const response = await http.get(`/api/v2/orders/admin`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailOrderItems = async (orderId, params) => {
  try {
    const response = await http.get(`/api/v2/orders/${orderId}/items`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getOrderDocument = async (orderId) => {
  try {
    const response = await http.get(`/api/v2/documents/orders/${orderId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const addOrderDocument = async (orderId, payload) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  try {
    const response = await http.post(`/api/v2/documents/orders/${orderId}`, payload, config)
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailTemplateBroadcastOrder = async (orderId) => {
  try {
    const response = await http.get(`/api/v2/orders/${orderId}/template-message`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const sendBroadcastMessageOrder = async (payload) => {
  try {
    const response = await http.post(`/api/v2/orders/send-custom-report`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const generateShortUrlOrder = async (orderId, payload) => {
  try {
    const response = await http.post(`/api/v2/orders/${orderId}/short-url`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const generateUrlPublicOrder = async (orderId) => {
  try {
    const response = await http.post(`/api/v2/orders/${orderId}/generate-url`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const addOrderProductItems = async (orderId, payload) => {
  try {
    const response = await http.post(`/api/v2/orders/${orderId}/additems`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const addOrder = async (payload) => {
  try {
    const response = await http.post(`/api/v2/orders`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateOrder = async (orderId, payload) => {
  try {
    const response = await http.put(`/api/v2/orders/${orderId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateOrderItemsStatus = async (orderId, payload) => {
  try {
    const response = await http.put(`/api/v2/orders/${orderId}/update-item-status`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}
export const updateOrderItemsImage = async (orderId, itemId, payload) => {
  try {
    const response = await http.post(`/api/v2/orders/${orderId}/items/${itemId}/image`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateOrderCustomCharges = async (orderId, customChargesId, payload) => {
  try {
    const response = await http.put(`/api/v2/orders/${orderId}/customs-charge/${customChargesId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteOrder = async (orderId, payload) => {
  try {
    const response = await http.delete(`/api/v2/orders/${orderId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteItemsOrder = async (orderId, itemId ) => {
  try {
    const response = await http.delete(`/api/v2/orders/${orderId}/items`, {
      data: {
        item_ids: [
          itemId
        ]
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addAdditionalLogistic = async (orderId, additionalLogisticId, payload) => {
  try {
    const response = await http.post(`/api/v2/orders/${orderId}/additional-charge/${additionalLogisticId}/details`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateAdditionalLogistic = async (orderId, additionalLogisticId, logisticId, payload) => {
  try {
    const response = await http.put(`/api/v2/orders/${orderId}/additional-charge/${additionalLogisticId}/details/${logisticId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteAdditionalLogistic = async (orderId, logisticId, additionalLogisticId) => {
  try {
    const response = await http.delete(`/api/v2/orders/${orderId}/additional-charge/${logisticId}/details/${additionalLogisticId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteAllItemsOrder = async (orderId) => {
  try {
    const response = await http.delete(`/api/v2/orders/${orderId}/items`, {
      data: {
        purge: true,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteOrderDocument = async (documentId) => {
  try {
    const response = await http.delete(`/api/v2/documents/${documentId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateOrderHistory = async (historyId, payload) => {
  try {
    const response = await http.put(`/api/v2/orders/status-history/${historyId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteOrderHistory = async (historyId) => {
  try {
    const response = await http.delete(`/api/v2/orders/status-history/${historyId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const getOrderInvoiceNumber = async (params) => {
  try {
    const response = await http.get(`/api/v2/order-invoice`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const generateOrderInvoiceNumber = async (payload) => {
  try {
    const response = await http.post(`/api/v2/order-invoice`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateOrderInvoiceNumber = async (invoiceId, payload) => {
  try {
    const response = await http.put(`/api/v2/order-invoice/${invoiceId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const getOrderCount = async (orderId) => {
  try {
    const response = await http.post(`/graphql`, {
      query: queryGetOrderCount,
      variables: { orderId },
    })
    return response.data
  } catch(error) {
    throw error
  }
}